import { LocationOn } from "@mui/icons-material";
import {
  Box,
  Paper,
  Typography,
  Divider,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { useRTL } from "hooks/isRTL";
import { useNavigate } from "react-router-dom";

const ActiveDriversLocation = ({
  drivers = [],
  currentDriver,
  setCurrentDriver,
  panToDriver,
  loading,
}) => {
  const { t } = useRTL();
  const navigate = useNavigate();

  const handleClick = (driverId) => {
    navigate(`/driverManagement/DriverDetails/${driverId}`);
  };

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : !drivers.length ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            textAlign: "center",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            {t("nodriversavailableatthemoment")}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Divider />
          {drivers.map((driver) => (
            <Paper
              key={driver.id}
              sx={{
                boxShadow: `0 -2px 6px rgba(0, 0, 0, 0.1), 0px 2px 1px -1px rgba(0,0,0,0.2),
            0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)`,
                padding: "1rem",
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                backgroundColor:
                  currentDriver?.id === driver.id ? "#d1cfcf" : "white",
                "&:hover": {
                  backgroundColor:
                    currentDriver?.id === driver.id ? "#d1cfcf" : "#f4f4f4",
                },
              }}
              onClick={() => setCurrentDriver(driver)}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(driver.driverId)}
                >
                  {driver.name}
                </Typography>

                <Tooltip title={t("viewDriverLocation")} arrow placement="top">
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      panToDriver(driver);
                    }}
                    color="primary"
                    size="small"
                    aria-label={t("viewDriverLocation")}
                  >
                    <LocationOn />
                  </IconButton>
                </Tooltip>
              </Box>

              <Typography variant="body2" color="text.black">
                {t("activeTime")}: {driver.activeTime}
              </Typography>

              <Typography variant="body2" color="text.black">
                {t("ActivephoneNumber")} : {driver.phoneNumber}
              </Typography>
            </Paper>
          ))}
        </Box>
      )}
    </>
  );
};

export default ActiveDriversLocation;
